module.exports = __webpack_public_path__ + "img/bgr-confetti-yellow.0924aae9.svg";